import { apiGet, apiPost, apiPut, apiDelete } from 'helpers/ApiHelper';
import Auth from 'j-toker';
import * as notifications from './notificationActions';
import * as dashboardActions from './dashboardActions';
import * as todo from './todoActions';
import { deepDiver } from 'helpers/utilities';
import { toISO8601DateString, objectToQuery } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';

export function showModifyBooking() {
  return {
    type: 'BOOKINGS::SHOW_MODIFY_SHOWING',
    modifyShowing: true,
  };
}

function updateAvailability(response) {
  return {
    type: 'BOOKINGS::UPDATE_BOOKING_AVAILABILITY',
    timeAvailability: response,
    select_availability: true,
  };
}

function apartmentAvailabilityError(error) {
  let message = getTranslatedString('backendErrors.noAvailabilities');
  if (error.responseJSON && error.responseJSON.error_code) {
    message = getTranslatedString(error.responseJSON.error_code);
  } else if (error.responseJSON.message) {
    message = error.responseJSON.message;
  }

  return {
    type: 'BOOKINGS::UPDATE_BOOKING_AVAILABILITY_ERROR',
    message,
  };
}

export function resetBookingsState() {
  return {
    type: 'BOOKINGS::RESET_BOOKING_STATE',
  };
}

export function removePreviousSearchResults() {
  return {
    type: 'BOOKINGS::REMOVE_PREVIOUS_SEARCH_RESULTS',
  };
}

export function setToIsLoading(isLoading = true) {
  return {
    type: 'BOOKINGS::SET_TO_IS_LOADING',
    isLoading,
  };
}

export function goBack() {
  return {
    type: 'LANDLORD_BOOKINGS::GO_BACK',
  };
}

export function collectLeadDetails(property_id, time, date) {
  return {
    type: 'LANDLORD_BOOKINGS::COLLECT_LEAD_DETAILS',
    bookingDetails: {
      property_id: property_id,
      time,
      date,
    },
  };
}

export function getAmenityPricing(amenityId, duration) {
  return dispatch =>
    apiGet(Auth.getApiUrl() + `/landlords/amenities/${amenityId}/pricing?duration=${duration}`)
      .done(response => {
        dispatch({
          type: 'BOOKINGS::AMENITY_PRICING',
          amenityPricing: response.pricing,
        });
      })
      .catch(error => {
        dispatch(notifications.showFailure(error));
        dispatch(notifications.showFailure("Sorry. We couldn't get the pricing for this amenity"));
      });
}

export function showAvailableAmenityBookings(
  amenity_id,
  requested_time,
  requested_date,
  requested_booking_length,
  original_booking_id
) {
  return dispatch =>
    apiPost(Auth.getApiUrl() + '/bookings/find_availability/amenity', {
      booking_type: 0,
      amenity_id,
      requested_time,
      requested_date,
      requested_booking_length,
      original_booking_id,
    })
      .done(response => {
        dispatch(updateAvailability(response.availabilities));
      })
      .catch(error => {
        console.error('request failed', error);
        if (error.responseJSON && error.responseJSON.error_code) {
          dispatch(notifications.showFailure(error.responseJSON.error_code));
        } else {
          dispatch(notifications.showFailure(error));
        }
        dispatch(apartmentAvailabilityError(error));
      });
}

export function getApartmentAvailability(property_id, booking_time, booking_date, unit_type_ids) {
  booking_date = toISO8601DateString(booking_date);
  const query = objectToQuery({
    property_id,
    unit_type_ids,
    requested_time: booking_time,
    requested_date: booking_date,
  });
  return dispatch =>
    apiGet(Auth.getApiUrl() + '/bookings/apartment_showings/find_availability' + query)
      .done(response => {
        dispatch(updateAvailability(response.availabilities));
      })
      .catch(error => {
        console.error('request failed', error);
        dispatch(apartmentAvailabilityError(error));
      });
}

export function updateBooking(property_id, booking_time, booking_date, booking_id, unit_type) {
  return dispatch =>
    apiPut(Auth.getApiUrl() + `/landlords/showings/${booking_id}`, {
      property_id: property_id,
      requested_time: booking_time,
      requested_date: booking_date,
      unit_type: unit_type,
    })
      .done(response => {
        dispatch(notifications.showSuccess('showingSuccessfullyUpdated'));
        dispatch(todo.getTenantTodoList());
        dispatch(closeDialog());
      })
      .catch(error => {
        console.error('request failed', error);
        dispatch(notifications.showFailure(error));
        dispatch(
          notifications.showFailure(
            'It looks like that time is no longer available. Please select another time.'
          )
        );
      });
}

export function confirmBooking() {
  return {
    type: 'LANDLORD_BOOKINGS::CONFIRM_BOOKING',
  };
}

export function cancelBooking(booking_id) {
  return dispatch =>
    apiPost(Auth.getApiUrl() + '/bookings/apartment_showings/cancel_booking', {
      booking_id: booking_id,
    })
      .done(response => {
        // dispatch(updateNotificationsInformation(response));
        dispatch(notifications.showSuccess('showingSuccessfullyCancelled'));
        dispatch(todo.getTenantTodoList());
        dispatch(closeDialog());
      })
      .catch(error => {
        dispatch(notifications.showFailure(error));
        console.error('request failed', error);
      });
}

export function openDialog() {
  return {
    type: 'BOOKINGS::OPEN_DIALOG',
  };
}

export function closeDialog() {
  return {
    type: 'BOOKINGS::CLOSE_DIALOG',
  };
}

export function bookAmenity(
  amenityId,
  requested_time,
  requested_date,
  requested_booking_length,
  booking_notes = null
) {
  let amenityDetails = {
    requested_time,
    requested_date,
    requested_booking_length,
    booking_notes,
  };

  return (dispatch, getState) => {
    amenityDetails['lead_id'] = deepDiver(getState(), 'landlordProperties.selectedTenantID');

    return apiPost(Auth.getApiUrl() + `/bookings/amenities/${amenityId}`, amenityDetails)
      .done(response => {
        dispatch(notifications.showSuccess('bookingSuccessfullyCreated'));
      })
      .catch(error => {
        dispatch(notifications.showFailure(error));
        console.error('request failed', error);
      });
  };
}

export function editAmenityBooking(
  bookable_id,
  requested_time,
  requested_date,
  requested_booking_length,
  token
) {
  return dispatch =>
    apiPut(Auth.getApiUrl() + `/bookings/${bookable_id}`, {
      requested_time,
      requested_date,
      requested_booking_length,
      token,
    })
      .done(response => {
        dispatch(notifications.showSuccess('bookingSuccessfullyUpdated'));
      })
      .catch(error => {
        dispatch(notifications.showFailure(error));
        console.error('request failed', error);
      });
}

export function cancelAmenityBooking(booking_id) {
  return dispatch =>
    apiDelete(Auth.getApiUrl() + `/bookings/${booking_id}`)
      .done(response => {
        dispatch(notifications.showSuccess('bookingSuccessfullyCancelled'));
        dispatch(dashboardActions.getTenancyStatus());
      })
      .catch(error => {
        dispatch(notifications.showFailure(error));
        console.error('request failed', error);
      });
}

export function leadCreateBooking(property_id, book_date, unit_type) {
  return dispatch =>
    apiPost(Auth.getApiUrl() + '/bookings/create_booking', {
      property_id: property_id,
      book_date: book_date,
      unit_type: unit_type,
    })
      .done(response => {
        dispatch(notifications.showSuccess('showingSuccessfullyCreated'));
      })
      .catch(error => {
        dispatch(notifications.showFailure(error));
        console.error('request failed', error);
      });
}

export function editAmenityBookingNotes(amenityId, notes) {
  return dispatch => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/bookings/${amenityId}`, { notes })
        .done(response => {
          dispatch(notifications.showSuccess('bookingNotesSuccessfullyUpdated'));
        })
        .catch((error, textStatus) => {
          dispatch(notifications.showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}
